import React from 'react';
import { Link } from 'react-router-dom';

const Error403Page = () => {
  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100 px-4">
      <div className="text-center max-w-md">
        <h1 className="text-9xl font-extrabold text-primary_main">403</h1>
        <p className="text-2xl md:text-3xl font-semibold mt-4 text-gray-800">Access Denied</p>
        <p className="mt-2 text-gray-600">
          You don't have permission to view this page.
        </p>
        <Link
          to="/"
          className="inline-block mt-6 px-6 py-3 bg-primary_main text-white text-sm font-medium rounded-lg shadow-md hover:bg-yellow-600 transition-all duration-300"
        >
          Go to Homepage
        </Link>
      </div>
    </div>
  );
};

export default Error403Page;
